module.exports = __webpack_public_path__ + "static/scale-model-of-heritage-neighborhood-in-austin-texas-39e7d69faeae7d534309b9c854149a50.png";